/** Allowed account lifecycle values on profiles (students). */
export const ACCOUNT_STATUSES = ['Active', 'Frozen', 'Deactivated'];

/**
 * Resolves effective account status from profile row (handles legacy `active` only).
 */
export function normalizeAccountStatus(user) {
    if (!user) return 'Active';
    const raw = user.status;
    if (raw != null && String(raw).trim() !== '') {
        const s = String(raw).trim();
        if (ACCOUNT_STATUSES.includes(s)) return s;
    }
    if (user.active === false) return 'Deactivated';
    return 'Active';
}

/** Teachers use this list: homework, attendance, bulk messages, enrollment, exercise assign. */
export function isStudentActiveForAssignments(user) {
    return normalizeAccountStatus(user) === 'Active';
}

export function isAccountDeactivated(user) {
    return normalizeAccountStatus(user) === 'Deactivated';
}

export function isAccountFrozen(user) {
    return normalizeAccountStatus(user) === 'Frozen';
}

/** Group enrollment visible in Online Lesson (Homework Check, Students panel, leaderboard). */
export function isEnrollmentActiveInOnlineLesson(enrollment, allUsers = {}) {
    if (!enrollment?.userId) return false;
    const user = allUsers[enrollment.userId];
    if (!user) return true;
    if (user.role === 'teacher') return false;
    return isStudentActiveForAssignments(user);
}

export function filterActiveEnrollmentsForOnlineLesson(enrollments, allUsers = {}) {
    return (enrollments || []).filter((en) => isEnrollmentActiveInOnlineLesson(en, allUsers));
}

export function filterActiveStudentIdsForOnlineLesson(studentIds, allUsers = {}) {
    return (studentIds || []).filter((id) => {
        const user = allUsers[id];
        if (!user || user.role === 'teacher') return false;
        return isStudentActiveForAssignments(user);
    });
}

/** UI: Blue / Purple / Gray for teacher tables */
export function accountStatusBadgeStyle(status) {
    const s = normalizeAccountStatus({ status });
    if (s === 'Frozen') return { bg: '#f5f3ff', color: '#6366f1', border: '#c4b5fd' };
    if (s === 'Deactivated') return { bg: '#f1f5f9', color: '#64748b', border: '#cbd5e1' };
    return { bg: '#eff6ff', color: '#2563eb', border: '#93c5fd' };
}
